import React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { Card, SimpleTable, SimpleTableHeader } from 'components';
import { useLocalErrorHandler } from 'hooks';
import { Color } from '_helpers';
import moment from 'moment';

const ExpertQualificationsContainer = ({
    qualificationsList, apiError, setErrorHandler, onPush,
}: Props) => {
    const [processing, setProcessing] = React.useState(false);

    useLocalErrorHandler(setErrorHandler);

    const listTableHeaders: SimpleTableHeader[] = [
        { title: 'СПЕЦИАЛЬНОСТЬ', columnStyles: { width: '100%' }, fieldName: 'title' },
        { title: 'СОК ДЕЙСТВИЯ', columnStyles: { minWidth: '12rem' }, fieldName: 'expireDate' },
        { title: 'СТАТУС', fieldName: 'issueDate' },
    ];

    const checkCertificateStatus = (issueDate: moment.Moment, expireDate: moment.Moment): boolean => moment().isBetween(issueDate, expireDate);

    const renderStatus = (isActualCertificate: boolean) => (
        <span style={{ color: `var(${isActualCertificate ? Color.Success : Color.Red})` }}>
            {isActualCertificate ? 'Действует' : 'Не действует'}
        </span>
    );

    const listTableRows = qualificationsList && qualificationsList.map(({
        id, title, regNumber, experienceStartDate,
    }) => ({
        id: id,
        columns: [
            `${regNumber} - ${title}`,
            `${moment().diff(experienceStartDate, 'year')}`,
        ],
    }));

    return (
        <Card
          withoutPadding
          title="Мои специальности"
          category="Список специальностей, присвоенных вам, как члену комиссии"
          apiError={apiError}
          showLoader={processing}
          show404Error={!listTableRows}
        >
            {listTableRows && (
                <SimpleTable
                  tableHeaders={listTableHeaders}
                  tableRows={listTableRows}
                  handleRowClick={examApplicationId => onPush(`/qualification-detail/${examApplicationId}`)}
                  placeholderText=" "
                />
            )}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    qualificationsList: state.auth.auth ? state.auth.auth.profile.qualifications : [],
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    setErrorHandler: dispatch.errors.setErrorHandler,
    onPush: (key: string) => dispatch(push(key)),
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;

export default connect(mapState, mapDispatch)(ExpertQualificationsContainer);
